import {
  PageHeader,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  DataTable,
  Badge,
  Button,
  LoadingSkeleton,
  type Column,
} from '@redbax/ui-kit';
import { RefreshCw } from 'lucide-react';
import type { VulnerabilitySyncStatus } from '@redbax/shared';
import { formatDateTime } from '@redbax/shared';
import {
  useVulnerabilitySyncStatus,
  useTriggerVulnerabilitySync,
} from '../api/admin-package-hooks';

const columns: Column<VulnerabilitySyncStatus>[] = [
  {
    key: 'ecosystem',
    header: 'Ecosystem',
    sortable: true,
    render: (row) => <Badge variant="secondary">{row.ecosystem}</Badge>,
  },
  {
    key: 'lastSyncedAt',
    header: 'Last Synced',
    sortable: true,
    render: (row) => formatDateTime(row.lastSyncedAt),
  },
  {
    key: 'recordCount',
    header: 'Records',
    sortable: true,
    render: (row) => row.recordCount.toLocaleString(),
  },
];

export function AdminVulnerabilitySyncPage() {
  const { data: statuses, isLoading } = useVulnerabilitySyncStatus();
  const triggerSync = useTriggerVulnerabilitySync();

  if (isLoading) {
    return (
      <div>
        <PageHeader
          title="Vulnerability Sync"
          description="Monitor and trigger vulnerability database synchronization"
        />
        <LoadingSkeleton rows={4} />
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="Vulnerability Sync"
        description="Monitor and trigger vulnerability database synchronization"
        actions={
          <Button
            onClick={() => triggerSync.mutate()}
            disabled={triggerSync.isPending}
          >
            <RefreshCw className={`mr-1 h-4 w-4 ${triggerSync.isPending ? 'animate-spin' : ''}`} />
            {triggerSync.isPending ? 'Syncing...' : 'Trigger Sync'}
          </Button>
        }
      />

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Sync Status by Ecosystem</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            columns={columns}
            data={statuses ?? []}
            keyExtractor={(row) => row.ecosystem}
            loading={isLoading}
            emptyMessage="No sync status available. Trigger a sync to begin."
          />
        </CardContent>
      </Card>
    </div>
  );
}
